import { Collapse } from "components/elements/Collapse";
import Styles from "components/glampartners/VerticalResults.module.scss";
import React from "react";
import { Utils } from "utils/Utils";

export const VerticalResults = ({ data }) => {
  const { table, totals } = data;

  return Object.keys(table).map((item, key) => {
    let xp = item.split("/");
    let dt = new Date(xp[1], parseInt(xp[0]) - 1, 1);
    let results = (
      <>
        <div key={key} className={Styles["month"]}>
          <h2>
            {dt.toLocaleString("pt-BR", { month: "long" })}
          </h2>
         
        </div>
        {renderUnits(table[item])}
        <div className={Styles["total"]}>
          <span><strong>Total</strong></span>
          <span> {Utils.toCurrency(totals[item])}</span>
        </div>
      </>
    );

    return (
      <Collapse children={results} />
    )
  });
};

const renderUnits = (units) => {
  return Object.keys(units).map((item, key) => {
    if(item === "Publi" && units[item].length < 1){
      return(
        <div className={Styles["unit-container"]} key={key}>
          <h3 className={Styles["unit"]}>{item}</h3>
          <p className={Styles["payment-type"]}>
            <span>Sem participação</span>
          </p>
        </div>
      );
    }

    return (
      <div className={Styles["unit-container"]} key={key}>
        <h3 className={Styles["unit"]}>{item}</h3>
        {renderSales(units[item])}
      </div>
    );
  });
};

const renderSales = (sales) => {

  if (sales.length < 1) {
    return(
      <p className={Styles["payment-type"]}>
        <span>Nenhuma venda</span>
      </p>
    ); 
  }

  return sales.map((item, key) => {
    return (
      <div className={Styles["payment-type"]} key={key}>
        <div >{item.paymentType}</div>
        <div>{Utils.toCurrency(item.payment)}</div>
      </div>
    );
  });
};